<template>
  <div class="ss__desktop__submenu__transition__wrapper">
    <transition name="ss__desktop__submenu__animation">
      <div
        ref="menuWrapper"
        v-show="menuItemHovered"
        class="ss__desktop__submenu__wrapper"
        @mouseleave="$emit('hide')">
        <transition name="ss__desktop__submenu__fade" mode="out-in">
          <template v-for="item in menu">
            <div
              v-if="item.name === menuItemHovered"
              class="ss__desktop__submenu"
              :key="item.name"
              :style="item.style"
              @mouseenter="$emit('show', item.name)"
              >
              <SsDesktopSubmenuItem
                v-for="menuSecondary in item.children"
                :key="menuSecondary.name || menuSecondary.key"
                :submenu="menuSecondary"
              />
            </div>
          </template>
        </transition>
      </div>
    </transition>

    <transition name="ss__desktop__submenu__fade">
      <div
        v-show="menuItemHovered"
        class="ss__desktop__submenu__mask"
      ></div>
    </transition>
  </div>
</template>

<script>
import SsDesktopSubmenuItem from '../SsDesktopSubmenuItem/index.vue'
import { getStylePropertyValue } from '@/utils/index.js'
export default {
  name: 'SsDesktopSubmenu',

  components: {
    SsDesktopSubmenuItem
  },

  props: {
    menuItemHovered: String,
    menu: Array
  },

  watch: {
    menuItemHovered () {
      const temp = this.menu.find(item => item.name === this.menuItemHovered)
      if (!temp) {
        this.$refs.menuWrapper.style.height = '0px'
      }
      this.$refs.menuWrapper.style.height = '350px'
      const style = (temp && temp.style) || ''
      if (style) {
        const h = getStylePropertyValue(style, '--h-SsCustomHeaderDesktopSubmenu')
        h && (this.$refs.menuWrapper.style.height = h)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__desktop__submenu__wrapper {
  position: fixed;
  left: 0px;
  width: 100%;
  z-index: 1;
  background: var(--B0-t);
  border-top: 1px solid var(--B3-t);
  transition: height .3s var(--a-func-default);
  box-shadow: 0px -1px var(--B3-t);;
  .ss__desktop__submenu {
    display: var(--display-SsCustomHeaderDesktopSubmenu, flex);
    flex-direction: var(--direction-SsCustomHeaderDesktopSubmenu, row);
    flex-wrap: var(--wrap-SsCustomHeaderDesktopSubmenu, wrap);
    justify-content: var(--justify-SsCustomHeaderDesktopSubmenu, space-between);
    column-gap: var(--gap-SsCustomHeaderDesktopSubmenu, 0);
    row-gap: var(--gap-SsCustomHeaderDesktopSubmenu, 0);
    width: var(--w-SsCustomHeaderDesktopSubmenu, 852px);
    height: var(--h-SsCustomHeaderDesktopSubmenu, 350px);
    box-sizing: border-box;
    padding-top: 40px;
    margin: auto;
  }
}

.ss__desktop__submenu__mask {
  position: fixed;
  top: var(--h-ssCustomHeader, 56px);
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--color-backdrop);
  backdrop-filter: blur(5px);
}

.ss__desktop__submenu__animation-enter-active,
.ss__desktop__submenu__animation-leave-active {
  transform: translateY(0px);
  opacity: 1;
  transition all 0.36s var(--a-func-default)
}
.ss__desktop__submenu__animation-enter,
.ss__desktop__submenu__animation-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.ss__desktop__submenu__fade-enter-active,
.ss__desktop__submenu__fade-leave-active {
  opacity: 1;
  transition all 0.15s var(--a-func-default)
}
.ss__desktop__submenu__fade-enter,
.ss__desktop__submenu__fade-leave-to {
  opacity: 0;
}
</style>
